import { atom, selector } from 'recoil'

export const chartState = atom({
  key: 'recipientsEmailChartState',
  default: {
    dailyCounters: [],
    loading: true,
  },
})

export const recipientState = atom({
  key: 'recipientsEmailRecipientState',
  default: {
    recipientProfile: {},
  },
})

export const tableStateSerach = atom({
  key: 'recipientsEmailTableStateSerach',
  default: {
    orderBy: 'RecipientCntOrderbyIdMessage',
    orderDescending: true,
    pageSize: 10,
    pageNumber: 1,
  },
})

export const tableStateResult = atom({
  key: 'recipientsEmailTableStateResult',
  default: {
    items: [],
    totalItems: 0,
  },
})

export const tableLoadingState = atom({
  key: 'recipientsTrend_tableLoadingState',
  default: true,
})

export const resultsStateEmptyState = selector({
  key: 'recipientsTrendEmptyState',
  get: ({ get }) => {
    const {
      totalItems,
      // searchState: { alias, status }
    } = get(tableStateResult)

    const loading = get(tableLoadingState)

    return !loading && totalItems === 0
  },
})
